import { z } from 'zod'

export const orderCreatedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string().nullable(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('ORDER CREATED'),
    referenceNumbers: z.array(
      z.object({
        type: z.string(),
        value: z.string(),
      }),
    ),
    orderDetail: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        condition: z.string(),
        services: z.array(
          z.object({
            condition: z.string(),
            mode: z.string(),
            description: z.string(),
            serviceLevel: z.string(),
            locations: z.array(
              z.object({
                chrLocationId: z.string(),
                customerLocationId: z.string(),
                type: z.string(),
                style: z.string(),
                name: z.string(),
                address: z.object({
                  addressLine1: z.string(),
                  addressLine2: z.string(),
                  city: z.string(),
                  stateProvinceCode: z.string().nullable(),
                  postalCode: z.string(),
                  country: z.string(),
                  latitude: z.number(),
                  longitude: z.number(),
                }),
                referenceNumbers: z.null(),
              }),
            ),
            items: z.array(
              z.object({
                quantity: z.number(),
                packagingType: z.string(),
                description: z.string(),
                productCode: z.string(),
                freightClass: z.string(),
                pluNumber: z.string().nullable(),
                skuNumber: z.string().nullable(),
                upcNumber: z.string().nullable(),
                insuranceValue: z.any().nullable(),
                minWeight: z.any().nullable(),
                minWeightUnitOfMeasure: z.string().nullable(),
                maxWeight: z.number(),
                maxWeightUnitOfMeasure: z.string(),
                length: z.any().nullable(),
                lengthUnitOfMeasure: z.string().nullable(),
                height: z.any().nullable(),
                heightUnitOfMeasure: z.string().nullable(),
                width: z.any().nullable(),
                widthUnitOfMeasure: z.string().nullable(),
                volume: z.any().nullable(),
                volumeUnitOfMeasure: z.string().nullable(),
                pallets: z.number().nullable(),
                palletSpaces: z.number().nullable(),
                trailerLengthUsed: z.number(),
                trailerLengthUsedUnitOfMeasure: z.string(),
                referenceNumbers: z.null(),
              }),
            ),
          }),
        ),
      }),
    ),
    loadNumbers: z.array(z.any()),
  }),
})

export const orderUpdatedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string().nullable(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('ORDER UPDATED'),
    referenceNumbers: z.array(
      z.object({
        type: z.string(),
        value: z.string(),
      }),
    ),
    orderDetail: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        condition: z.string(),
        services: z.array(
          z.object({
            condition: z.string(),
            mode: z.string(),
            description: z.string(),
            serviceLevel: z.string(),
            locations: z.array(
              z.object({
                chrLocationId: z.string(),
                customerLocationId: z.string(),
                type: z.string(),
                style: z.string(),
                name: z.string(),
                address: z.object({
                  addressLine1: z.string(),
                  addressLine2: z.string().nullable(),
                  city: z.string(),
                  stateProvinceCode: z.string().nullable(),
                  postalCode: z.string(),
                  country: z.string(),
                  latitude: z.number(),
                  longitude: z.number(),
                }),
                referenceNumbers: z.array(
                  z.object({
                    type: z.string(),
                    value: z.string(),
                  }),
                ),
              }),
            ),
            items: z.array(
              z.object({
                quantity: z.number(),
                packagingType: z.string(),
                description: z.string(),
                productCode: z.string(),
                freightClass: z.string(),
                pluNumber: z.string().nullable(),
                skuNumber: z.string().nullable(),
                upcNumber: z.string().nullable(),
                insuranceValue: z.number().nullable(),
                minWeight: z.number().nullable(),
                minWeightUnitOfMeasure: z.string().nullable(),
                maxWeight: z.number(),
                maxWeightUnitOfMeasure: z.string(),
                length: z.number().nullable(),
                lengthUnitOfMeasure: z.string().nullable(),
                height: z.number().nullable(),
                heightUnitOfMeasure: z.string().nullable(),
                width: z.number().nullable(),
                widthUnitOfMeasure: z.string().nullable(),
                volume: z.number().nullable(),
                volumeUnitOfMeasure: z.string().nullable(),
                pallets: z.number().nullable(),
                palletSpaces: z.number().nullable(),
                trailerLengthUsed: z.number(),
                trailerLengthUsedUnitOfMeasure: z.string(),
                referenceNumbers: z.array(
                  z.object({
                    type: z.string(),
                    value: z.string(),
                  }),
                ),
              }),
            ),
          }),
        ),
      }),
    ),
    loadNumbers: z.array(z.number()),
  }),
})

export const orderCanceledSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string().nullable(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('ORDER CANCELED'),
    referenceNumbers: z.array(
      z.object({
        type: z.string(),
        value: z.string(),
      }),
    ),
    orderDetail: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        condition: z.string(),
        services: z.array(
          z.object({
            condition: z.string(),
            mode: z.string(),
            description: z.string(),
            serviceLevel: z.string(),
            locations: z.array(
              z.object({
                chrLocationId: z.string(),
                customerLocationId: z.string(),
                type: z.string(),
                style: z.string(),
                name: z.string(),
                address: z.object({
                  addressLine1: z.string(),
                  addressLine2: z.string(),
                  city: z.string(),
                  stateProvinceCode: z.string().nullable(),
                  postalCode: z.string(),
                  country: z.string(),
                  latitude: z.number(),
                  longitude: z.number(),
                }),
                referenceNumbers: z.array(
                  z.object({
                    type: z.string(),
                    value: z.string(),
                  }),
                ),
              }),
            ),
            items: z.array(
              z.object({
                quantity: z.number(),
                packagingType: z.string(),
                description: z.string(),
                productCode: z.string(),
                freightClass: z.string(),
                pluNumber: z.string().nullable(),
                skuNumber: z.string().nullable(),
                upcNumber: z.string().nullable(),
                insuranceValue: z.any().nullable(),
                minWeight: z.any().nullable(),
                minWeightUnitOfMeasure: z.string().nullable(),
                maxWeight: z.number(),
                maxWeightUnitOfMeasure: z.string(),
                length: z.any().nullable(),
                lengthUnitOfMeasure: z.string().nullable(),
                height: z.any().nullable(),
                heightUnitOfMeasure: z.string().nullable(),
                width: z.any().nullable(),
                widthUnitOfMeasure: z.string().nullable(),
                volume: z.any().nullable(),
                volumeUnitOfMeasure: z.string().nullable(),
                pallets: z.any().nullable(),
                palletSpaces: z.any().nullable(),
                trailerLengthUsed: z.number(),
                trailerLengthUsedUnitOfMeasure: z.string(),
                referenceNumbers: z.array(
                  z.object({
                    type: z.string(),
                    value: z.string(),
                  }),
                ),
              }),
            ),
          }),
        ),
      }),
    ),
    loadNumbers: z.array(z.any()),
  }),
})

export const orderRejectedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('ORDER REJECTED'),
    referenceNumbers: z.array(
      z.object({
        type: z.string(),
        value: z.string(),
      }),
    ),
    orderDetail: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        condition: z.string(),
        services: z.array(
          z.object({
            condition: z.string(),
            mode: z.string(),
            description: z.string(),
            serviceLevel: z.string(),
            locations: z.array(
              z.object({
                chrLocationId: z.string(),
                customerLocationId: z.string(),
                type: z.string(),
                style: z.string(),
                name: z.string(),
                address: z.object({
                  addressLine1: z.string(),
                  addressLine2: z.string().nullable(),
                  city: z.string(),
                  stateProvinceCode: z.string().nullable(),
                  postalCode: z.string(),
                  country: z.string(),
                  latitude: z.number(),
                  longitude: z.number(),
                }),
                referenceNumbers: z.array(
                  z.object({
                    type: z.string(),
                    value: z.string(),
                  }),
                ),
              }),
            ),
            items: z.array(
              z.object({
                quantity: z.number(),
                packagingType: z.string(),
                description: z.string(),
                productCode: z.string(),
                freightClass: z.string(),
                pluNumber: z.string().nullable(),
                skuNumber: z.string(),
                upcNumber: z.string().nullable(),
                insuranceValue: z.number().nullable(),
                minWeight: z.number(),
                minWeightUnitOfMeasure: z.string(),
                maxWeight: z.number(),
                maxWeightUnitOfMeasure: z.string(),
                length: z.number().nullable(),
                lengthUnitOfMeasure: z.string().nullable(),
                height: z.number().nullable(),
                heightUnitOfMeasure: z.string().nullable(),
                width: z.number().nullable(),
                widthUnitOfMeasure: z.string().nullable(),
                volume: z.number().nullable(),
                volumeUnitOfMeasure: z.string().nullable(),
                pallets: z.number().nullable(),
                palletSpaces: z.number().nullable(),
                trailerLengthUsed: z.number(),
                trailerLengthUsedUnitOfMeasure: z.string(),
                referenceNumbers: z.array(
                  z.object({
                    type: z.string(),
                    value: z.string(),
                  }),
                ),
              }),
            ),
          }),
        ),
      }),
    ),
    loadNumbers: z.array(z.any()),
  }),
})

export const orderCompletedSchema = z.object({
  time: z.string().datetime(),
  customer: z.string(),
  eventTime: z.string().datetime(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('ORDER COMPLETED'),
    referenceNumbers: z.array(
      z.object({
        type: z.string(),
        value: z.string(),
      }),
    ),
    orderDetail: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string().url(),
        orderNumber: z.number(),
        condition: z.string(),
        services: z.array(
          z.object({
            condition: z.string(),
            mode: z.string(),
            description: z.string(),
            serviceLevel: z.string(),
            locations: z.array(
              z.object({
                chrLocationId: z.string(),
                customerLocationId: z.string(),
                type: z.string(),
                style: z.string(),
                name: z.string(),
                address: z.object({
                  addressLine1: z.string(),
                  addressLine2: z.string().nullable(),
                  city: z.string(),
                  stateProvinceCode: z.string().nullable(),
                  postalCode: z.string(),
                  country: z.string(),
                  latitude: z.number(),
                  longitude: z.number(),
                }),
                referenceNumbers: z.array(
                  z.object({
                    type: z.string(),
                    value: z.string(),
                  }),
                ),
              }),
            ),
            items: z.array(
              z.object({
                quantity: z.number(),
                packagingType: z.string(),
                description: z.string(),
                productCode: z.string(),
                freightClass: z.string(),
                pluNumber: z.string().nullable(),
                skuNumber: z.string().nullable(),
                upcNumber: z.string().nullable(),
                insuranceValue: z.any().nullable(),
                minWeight: z.number(),
                minWeightUnitOfMeasure: z.string(),
                maxWeight: z.number(),
                maxWeightUnitOfMeasure: z.string(),
                length: z.number().nullable(),
                lengthUnitOfMeasure: z.string().nullable(),
                height: z.number().nullable(),
                heightUnitOfMeasure: z.string().nullable(),
                width: z.number().nullable(),
                widthUnitOfMeasure: z.string().nullable(),
                volume: z.number().nullable(),
                volumeUnitOfMeasure: z.string().nullable(),
                pallets: z.any().nullable(),
                palletSpaces: z.any().nullable(),
                trailerLengthUsed: z.number(),
                trailerLengthUsedUnitOfMeasure: z.string(),
                referenceNumbers: z.array(
                  z.object({
                    type: z.string(),
                    value: z.string(),
                  }),
                ),
              }),
            ),
          }),
        ),
      }),
    ),
    loadNumbers: z.array(z.number()),
  }),
})

export const loadCreatedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('LOAD CREATED'),
    orderDetails: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        customerOrderReferenceNumber: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    loadNumber: z.number(),
    equipmentType: z.string(),
    mode: z.null(),
    serviceOffering: z.string(),
    readyByDate: z.string(),
    pickupByDate: z.string(),
    deliveryAvailableByDate: z.string(),
    deliveryByDate: z.string(),
    billTos: z.array(
      z.object({
        customerCode: z.string(),
        customerName: z.string(),
        currencyCode: z.string(),
        invoiceMethod: z.string(),
        milesBilled: z.number(),
        exchangeRate: z.number(),
        charges: z.array(
          z.object({
            rate: z.number(),
            rateCode: z.string(),
            quantity: z.number(),
            alternateDescription: z.string(),
            chargeType: z.string(),
          }),
        ),
        contacts: z.array(
          z.object({
            name: z.string(),
            type: z.nullable(z.string()),
            companyName: z.string(),
            contactMethods: z.array(
              z.object({
                method: z.string(),
                value: z.string(),
              }),
            ),
            referenceNumbers: z.null(),
          }),
        ),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    customers: z.array(
      z.object({
        customerCode: z.string(),
        customerName: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        contacts: z.array(
          z.object({
            name: z.string(),
            type: z.string(),
            companyName: z.null(),
            contactMethods: z.array(z.any()),
            referenceNumbers: z.null(),
          }),
        ),
      }),
    ),
    carrier: z.object({
      name: z.null(),
      carrierCode: z.null(),
      scac: z.null(),
      proNumber: z.null(),
      driverName: z.null(),
      driverPhone: z.null(),
      secondDriverName: z.null(),
      sealNumber: z.null(),
      licensePlate: z.null(),
      tractorNumber: z.null(),
      trailerNumber: z.null(),
      dotNumber: z.null(),
    }),
    locations: z.array(
      z.object({
        chrLocationId: z.string(),
        customerLocationId: z.null(),
        type: z.string(),
        style: z.string(),
        stopSequenceNumber: z.number(),
        sequenceNumber: z.number(),
        name: z.string(),
        address: z.object({
          addressLine1: z.string(),
          addressLine2: z.null(),
          city: z.string(),
          stateProvinceCode: z.string(),
          postalCode: z.string(),
          country: z.string(),
          latitude: z.number(),
          longitude: z.number(),
        }),
        pickUpNumber: z.string().nullable(),
        deliveryNumber: z.string().nullable(),
        locationContact: z.object({
          name: z.string(),
          phoneNumber: z.string(),
          email: z.string().nullable(),
        }),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        appointmentNumber: z.null(),
        scheduledOpenDateTime: z.null(),
        scheduledCloseDateTime: z.null(),
        scheduledEnteredDate: z.null(),
        arrivalDateTime: z.null(),
        departureDateTime: z.null(),
        isDropTrailerNeeded: z.boolean(),
        scheduledWith: z.null(),
        etaDateTime: z.null(),
      }),
    ),
    items: z.array(
      z.object({
        packagingType: z.string(),
        description: z.string(),
        productCode: z.string(),
        freightClass: z.null(),
        insuranceValue: z.number(),
        primaryReferenceNumber: z.null(),
        poNumber: z.string(),
        skuNumber: z.string(),
        pluNumber: z.null(),
        actualQuantity: z.number(),
        actualWeight: z.number(),
        actualWeightUnitOfMeasure: z.string(),
        actualPallets: z.null(),
        actualVolume: z.number(),
        actualVolumeUnitOfMeasure: z.string(),
        actualPackagingLength: z.null(),
        actualPackagingHeight: z.null(),
        actualPackagingWidth: z.null(),
        actualPackagingUnitOfMeasure: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        associatedStop: z.object({
          pickSequenceNumber: z.number(),
          dropSequenceNumber: z.number(),
        }),
        expectedPallets: z.null(),
        expectedQuantity: z.number(),
        expectedWeight: z.number(),
        expectedWeightUnitOfMeasure: z.string(),
        expectedPackagingLength: z.null(),
        expectedPackagingHeight: z.null(),
        expectedPackagingWidth: z.null(),
        expectedPackagingUnitOfMeasure: z.string(),
        expectedVolume: z.null(),
        expectedVolumeUnitOfMeasure: z.null(),
      }),
    ),
    packages: z.array(z.any()),
  }),
})

export const loadBookedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('LOAD BOOKED'),
    orderDetails: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        customerOrderReferenceNumber: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    loadNumber: z.number(),
    equipmentType: z.string(),
    mode: z.string(),
    serviceOffering: z.string(),
    readyByDate: z.string(),
    pickupByDate: z.string(),
    deliveryAvailableByDate: z.string(),
    deliveryByDate: z.string(),
    billTos: z.array(
      z.object({
        customerCode: z.string(),
        customerName: z.string(),
        currencyCode: z.string(),
        invoiceMethod: z.string(),
        milesBilled: z.number(),
        exchangeRate: z.number(),
        charges: z.array(
          z.object({
            rate: z.number(),
            rateCode: z.string(),
            quantity: z.number(),
            alternateDescription: z.string(),
            chargeType: z.string(),
          }),
        ),
        contacts: z.array(
          z.object({
            name: z.string(),
            type: z.nullable(z.string()),
            companyName: z.string(),
            contactMethods: z.array(
              z.object({
                method: z.string(),
                value: z.string(),
              }),
            ),
            referenceNumbers: z.nullable(z.any()),
          }),
        ),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    customers: z.array(
      z.object({
        customerCode: z.string(),
        customerName: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        contacts: z.array(
          z.object({
            name: z.string(),
            type: z.string(),
            companyName: z.nullable(z.string()),
            contactMethods: z.array(z.any()),
            referenceNumbers: z.nullable(z.any()),
          }),
        ),
      }),
    ),
    carrier: z.object({
      name: z.string(),
      carrierCode: z.string(),
      scac: z.string(),
      proNumber: z.nullable(z.any()),
      driverName: z.nullable(z.any()),
      driverPhone: z.nullable(z.any()),
      secondDriverName: z.nullable(z.any()),
      sealNumber: z.nullable(z.any()),
      licensePlate: z.nullable(z.any()),
      tractorNumber: z.nullable(z.any()),
      trailerNumber: z.nullable(z.any()),
      dotNumber: z.string(),
    }),
    locations: z.array(
      z.object({
        chrLocationId: z.string(),
        customerLocationId: z.nullable(z.any()),
        type: z.string(),
        style: z.string(),
        stopSequenceNumber: z.number(),
        sequenceNumber: z.number(),
        name: z.string(),
        address: z.object({
          addressLine1: z.string(),
          addressLine2: z.nullable(z.any()),
          city: z.string(),
          stateProvinceCode: z.string(),
          postalCode: z.string(),
          country: z.string(),
          latitude: z.number(),
          longitude: z.number(),
        }),
        pickUpNumber: z.nullable(z.string()),
        deliveryNumber: z.nullable(z.string()),
        locationContact: z.object({
          name: z.string(),
          phoneNumber: z.string(),
          email: z.nullable(z.any()),
        }),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        appointmentNumber: z.nullable(z.string()),
        scheduledOpenDateTime: z.string(),
        scheduledCloseDateTime: z.string(),
        scheduledEnteredDate: z.string(),
        arrivalDateTime: z.nullable(z.any()),
        departureDateTime: z.nullable(z.any()),
        isDropTrailerNeeded: z.boolean(),
        scheduledWith: z.string(),
        etaDateTime: z.string(),
      }),
    ),
    items: z.array(
      z.object({
        packagingType: z.string(),
        description: z.string(),
        productCode: z.string(),
        freightClass: z.nullable(z.any()),
        insuranceValue: z.number(),
        primaryReferenceNumber: z.nullable(z.any()),
        poNumber: z.string(),
        skuNumber: z.string(),
        pluNumber: z.nullable(z.any()),
        actualQuantity: z.number(),
        actualWeight: z.number(),
        actualWeightUnitOfMeasure: z.string(),
        actualPallets: z.nullable(z.any()),
        actualVolume: z.number(),
        actualVolumeUnitOfMeasure: z.string(),
        actualPackagingLength: z.nullable(z.any()),
        actualPackagingHeight: z.nullable(z.any()),
        actualPackagingWidth: z.nullable(z.any()),
        actualPackagingUnitOfMeasure: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        associatedStop: z.object({
          pickSequenceNumber: z.number(),
          dropSequenceNumber: z.number(),
        }),
        expectedPallets: z.nullable(z.any()),
        expectedQuantity: z.number(),
        expectedWeight: z.number(),
        expectedWeightUnitOfMeasure: z.string(),
        expectedPackagingLength: z.nullable(z.any()),
        expectedPackagingHeight: z.nullable(z.any()),
        expectedPackagingWidth: z.nullable(z.any()),
        expectedPackagingUnitOfMeasure: z.string(),
        expectedVolume: z.nullable(z.any()),
        expectedVolumeUnitOfMeasure: z.nullable(z.any()),
      }),
    ),
    packages: z.array(z.any()),
  }),
})

export const loadCancelledSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('LOAD CANCELLED'),
    orderDetails: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        customerOrderReferenceNumber: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    loadNumber: z.number(),
    equipmentType: z.string(),
    mode: z.null(),
    serviceOffering: z.string(),
    readyByDate: z.string(),
    pickupByDate: z.string(),
    deliveryAvailableByDate: z.string(),
    deliveryByDate: z.string(),
    billTos: z.array(
      z.object({
        customerCode: z.string(),
        customerName: z.string(),
        currencyCode: z.string(),
        invoiceMethod: z.string(),
        milesBilled: z.number(),
        exchangeRate: z.number(),
        charges: z.array(
          z.object({
            rate: z.number(),
            rateCode: z.string(),
            quantity: z.number(),
            alternateDescription: z.string(),
            chargeType: z.string(),
          }),
        ),
        contacts: z.array(
          z.object({
            name: z.string(),
            type: z.null(),
            companyName: z.string(),
            contactMethods: z.array(
              z.object({
                method: z.string(),
                value: z.string(),
              }),
            ),
            referenceNumbers: z.null(),
          }),
        ),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    customers: z.array(
      z.object({
        customerCode: z.string(),
        customerName: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        contacts: z.array(
          z.object({
            name: z.string(),
            type: z.string(),
            companyName: z.null(),
            contactMethods: z.array(z.any()),
            referenceNumbers: z.null(),
          }),
        ),
      }),
    ),
    carrier: z.object({
      name: z.string(),
      carrierCode: z.string(),
      scac: z.string(),
      proNumber: z.nullable(z.any()),
      driverName: z.nullable(z.any()),
      driverPhone: z.nullable(z.any()),
      secondDriverName: z.nullable(z.any()),
      sealNumber: z.nullable(z.any()),
      licensePlate: z.nullable(z.any()),
      tractorNumber: z.nullable(z.any()),
      trailerNumber: z.nullable(z.any()),
      dotNumber: z.string(),
    }),
    locations: z.array(
      z.object({
        chrLocationId: z.string(),
        customerLocationId: z.null(),
        type: z.string(),
        style: z.string(),
        stopSequenceNumber: z.number(),
        sequenceNumber: z.number(),
        name: z.string(),
        address: z.object({
          addressLine1: z.string(),
          addressLine2: z.null(),
          city: z.string(),
          stateProvinceCode: z.string(),
          postalCode: z.string(),
          country: z.string(),
          latitude: z.number(),
          longitude: z.number(),
        }),
        pickUpNumber: z.string().nullable(),
        deliveryNumber: z.string().nullable(),
        locationContact: z.object({
          name: z.string(),
          phoneNumber: z.string(),
          email: z.string().nullable(),
        }),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        appointmentNumber: z.null(),
        scheduledOpenDateTime: z.string().nullable(),
        scheduledCloseDateTime: z.string().nullable(),
        scheduledEnteredDate: z.string().nullable(),
        arrivalDateTime: z.string().nullable(),
        departureDateTime: z.string().nullable(),
        isDropTrailerNeeded: z.boolean(),
        scheduledWith: z.string().nullable(),
        etaDateTime: z.string().nullable(),
      }),
    ),
    items: z.array(
      z.object({
        packagingType: z.string(),
        description: z.string(),
        productCode: z.string(),
        freightClass: z.null(),
        insuranceValue: z.number(),
        primaryReferenceNumber: z.null(),
        poNumber: z.string(),
        skuNumber: z.null(),
        pluNumber: z.null(),
        actualQuantity: z.number(),
        actualWeight: z.number(),
        actualWeightUnitOfMeasure: z.string(),
        actualPallets: z.null(),
        actualVolume: z.number(),
        actualVolumeUnitOfMeasure: z.string(),
        actualPackagingLength: z.null(),
        actualPackagingHeight: z.null(),
        actualPackagingWidth: z.null(),
        actualPackagingUnitOfMeasure: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        associatedStop: z.object({
          pickSequenceNumber: z.number(),
          dropSequenceNumber: z.number(),
        }),
        expectedPallets: z.null(),
        expectedQuantity: z.number(),
        expectedWeight: z.number(),
        expectedWeightUnitOfMeasure: z.string(),
        expectedPackagingLength: z.null(),
        expectedPackagingHeight: z.null(),
        expectedPackagingWidth: z.null(),
        expectedPackagingUnitOfMeasure: z.string(),
        expectedVolume: z.null(),
        expectedVolumeUnitOfMeasure: z.null(),
      }),
    ),
    packages: z.array(z.any()),
  }),
})

export const carrierArrivedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('CARRIER ARRIVED'),
    orderDetails: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        customerOrderReferenceNumber: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    loadNumber: z.number(),
    carrier: z.object({
      name: z.string(),
      carrierCode: z.string(),
      scac: z.string(),
      proNumber: z.string().nullable(),
      driverName: z.string().nullable(),
      driverPhone: z.string(),
      secondDriverName: z.string().nullable(),
      sealNumber: z.string().nullable(),
      licensePlate: z.string().nullable(),
      tractorNumber: z.string(),
      trailerNumber: z.string(),
      dotNumber: z.string(),
    }),
    location: z.object({
      chrLocationId: z.string(),
      customerLocationId: z.string().nullable(),
      type: z.string(),
      style: z.string(),
      stopSequenceNumber: z.number(),
      sequenceNumber: z.number(),
      name: z.string(),
      address: z.object({
        addressLine1: z.string(),
        addressLine2: z.string().nullable(),
        city: z.string(),
        stateProvinceCode: z.string(),
        postalCode: z.string(),
        country: z.string(),
        latitude: z.number(),
        longitude: z.number(),
      }),
      pickUpNumber: z.string().nullable(),
      deliveryNumber: z.string().nullable(),
      locationContact: z.object({
        name: z.string(),
        phoneNumber: z.string(),
        email: z.string().nullable(),
      }),
      referenceNumbers: z.array(
        z.object({
          type: z.string(),
          value: z.string(),
        }),
      ),
    }),
    items: z.array(
      z.object({
        packagingType: z.string(),
        description: z.string(),
        productCode: z.string(),
        freightClass: z.string().nullable(),
        insuranceValue: z.number(),
        primaryReferenceNumber: z.string().nullable(),
        poNumber: z.string(),
        skuNumber: z.string().nullable(),
        pluNumber: z.string().nullable(),
        actualQuantity: z.number(),
        actualWeight: z.number(),
        actualWeightUnitOfMeasure: z.string(),
        actualPallets: z.number().nullable(),
        actualVolume: z.number(),
        actualVolumeUnitOfMeasure: z.string(),
        actualPackagingLength: z.number().nullable(),
        actualPackagingHeight: z.number().nullable(),
        actualPackagingWidth: z.number().nullable(),
        actualPackagingUnitOfMeasure: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        associatedStop: z.object({
          pickSequenceNumber: z.number().nullable(),
          dropSequenceNumber: z.number().nullable(),
        }),
      }),
    ),
    packages: z.array(z.any()),
  }),
})

export const carrierDepartedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('CARRIER DEPARTED'),
    orderDetails: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        customerOrderReferenceNumber: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    loadNumber: z.number(),
    carrier: z.object({
      name: z.string(),
      carrierCode: z.string(),
      scac: z.string(),
      proNumber: z.string().nullable(),
      driverName: z.string(),
      driverPhone: z.string(),
      secondDriverName: z.string().nullable(),
      sealNumber: z.string().nullable(),
      licensePlate: z.string().nullable(),
      tractorNumber: z.string(),
      trailerNumber: z.string(),
      dotNumber: z.string(),
    }),
    location: z.object({
      chrLocationId: z.string(),
      customerLocationId: z.string().nullable(),
      type: z.string(),
      style: z.string(),
      stopSequenceNumber: z.number(),
      sequenceNumber: z.number(),
      name: z.string(),
      address: z.object({
        addressLine1: z.string(),
        addressLine2: z.string().nullable(),
        city: z.string(),
        stateProvinceCode: z.string(),
        postalCode: z.string(),
        country: z.string(),
        latitude: z.number(),
        longitude: z.number(),
      }),
      pickUpNumber: z.string().nullable(),
      deliveryNumber: z.string().nullable(),
      locationContact: z.object({
        name: z.string(),
        phoneNumber: z.string(),
        email: z.string().nullable(),
      }),
      referenceNumbers: z.array(
        z.object({
          type: z.string(),
          value: z.string(),
        }),
      ),
    }),
    items: z.array(
      z.object({
        packagingType: z.string(),
        description: z.string(),
        productCode: z.string(),
        freightClass: z.any().nullable(),
        insuranceValue: z.number(),
        primaryReferenceNumber: z.string().nullable(),
        poNumber: z.string(),
        skuNumber: z.string(),
        pluNumber: z.string().nullable(),
        actualQuantity: z.number(),
        actualWeight: z.number(),
        actualWeightUnitOfMeasure: z.string(),
        actualPallets: z.any().nullable(),
        actualVolume: z.number(),
        actualVolumeUnitOfMeasure: z.string(),
        actualPackagingLength: z.any().nullable(),
        actualPackagingHeight: z.any().nullable(),
        actualPackagingWidth: z.any().nullable(),
        actualPackagingUnitOfMeasure: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        associatedStop: z.object({
          pickSequenceNumber: z.any().nullable(),
          dropSequenceNumber: z.any().nullable(),
        }),
      }),
    ),
    packages: z.array(z.any()),
  }),
})

export const appointmentUpdatedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('APPOINTMENT UPDATED'),
    orderDetails: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        orderNumber: z.number(),
        customerOrderReferenceNumber: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    loadNumber: z.number(),
    carrier: z.object({
      name: z.string().nullable(),
      carrierCode: z.string().nullable(),
      scac: z.string().nullable(),
      proNumber: z.string().nullable(),
      driverName: z.string().nullable(),
      driverPhone: z.string().nullable(),
      secondDriverName: z.string().nullable(),
      sealNumber: z.string().nullable(),
      licensePlate: z.string().nullable(),
      tractorNumber: z.string().nullable(),
      trailerNumber: z.string().nullable(),
      dotNumber: z.string().nullable(),
    }),
    location: z.object({
      chrLocationId: z.string(),
      customerLocationId: z.string().nullable(),
      type: z.string(),
      style: z.string(),
      stopSequenceNumber: z.number(),
      sequenceNumber: z.number(),
      name: z.string(),
      address: z.object({
        addressLine1: z.string(),
        addressLine2: z.string().nullable(),
        city: z.string(),
        stateProvinceCode: z.string(),
        postalCode: z.string(),
        country: z.string(),
        latitude: z.number(),
        longitude: z.number(),
      }),
      pickUpNumber: z.string().nullable(),
      deliveryNumber: z.string().nullable(),
      locationContact: z.object({
        name: z.string(),
        phoneNumber: z.string(),
        email: z.string(),
      }),
      referenceNumbers: z.array(
        z.object({
          type: z.string(),
          value: z.string(),
        }),
      ),
    }),
    appointment: z.object({
      scheduledOpenDateTimeUTC: z.string(),
      scheduledCloseDateTimeUTC: z.string(),
      changeReason: z.string(),
      scheduledCompany: z.string(),
      scheduledWithName: z.string(),
    }),
  }),
})

export const inTransitSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('IN TRANSIT'),
    orderDetails: z.array(
      z.object({
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string().url(),
        orderNumber: z.number(),
        customerOrderReferenceNumber: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    loadNumber: z.number(),
    carrier: z.object({
      name: z.string(),
      carrierCode: z.string(),
      scac: z.string(),
      proNumber: z.string().nullable(),
      driverName: z.string(),
      driverPhone: z.string(),
      secondDriverName: z.string().nullable(),
      sealNumber: z.string().nullable(),
      licensePlate: z.string().nullable(),
      tractorNumber: z.string(),
      trailerNumber: z.string(),
      dotNumber: z.string(),
    }),
    location: z.object({
      city: z.string(),
      stateProvinceCode: z.string().nullable(),
      country: z.string().nullable(),
      latitude: z.number(),
      longitude: z.number(),
    }),
    deliveryEta: z.string(),
    nextStop: z.object({
      eta: z.string(),
      stopId: z.string(),
      stopType: z.string(),
      city: z.string(),
      state: z.string(),
    }),
    notes: z.string().nullable(),
  }),
})

export const cargoDeliveredSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  event: z.object({
    agentReferenceNumber: z.any().nullable(),
    airShipment: z.any().nullable(),
    consignee: z.object({
      name: z.string(),
    }),
    customer: z.object({
      name: z.string(),
    }),
    customerReferenceNumber: z.string(),
    customs: z.object({
      auCustoms: z.object({
        n10: z.any().nullable(),
      }),
      nzCustoms: z.object({
        n10: z.any().nullable(),
      }),
    }),
    customsEntry: z.any().nullable(),
    estimatedCargoReadyDate: z.object({
      currentValue: z.string(),
      hasChanged: z.boolean(),
      previousValue: z.string(),
    }),
    estimatedDeliverByDate: z.object({
      currentValue: z.string(),
      hasChanged: z.boolean(),
      previousValue: z.string(),
    }),
    eventType: z.literal('CARGO DELIVERED'),
    freightTerms: z.string(),
    incoLocation: z.string(),
    incoTerms: z.string(),
    mode: z.string(),
    oceanShipment: z.object({
      actualVesselArrivalDate: z.object({
        currentValue: z.string(),
        hasChanged: z.boolean(),
        previousValue: z.string(),
      }),
      actualVesselDepartureDate: z.object({
        currentValue: z.string(),
        hasChanged: z.boolean(),
        previousValue: z.string(),
      }),
      containers: z.array(
        z.object({
          actualDeliveryDate: z.object({
            currentValue: z.string().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.string().nullable(),
          }),
          actualPickupDate: z.object({
            currentValue: z.string().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.string().nullable(),
          }),
          containerNumber: z.string(),
          containerType: z.string(),
          emptyPickupDate: z.object({
            currentValue: z.any().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.any().nullable(),
          }),
          emptyReturnDate: z.object({
            currentValue: z.string().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.string().nullable(),
          }),
          estimatedDeliveryDate: z.object({
            currentValue: z.string().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.string().nullable(),
          }),
          estimatedPickupDate: z.object({
            currentValue: z.string().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.string().nullable(),
          }),
          innerPacks: z.array(
            z.object({
              unitOfMeasure: z.string(),
              value: z.number(),
            }),
          ),
          isAffectedByEvent: z.boolean(),
          lastFreeDay: z.object({
            currentValue: z.any().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.any().nullable(),
          }),
          lastFreeDayForEmptyReturn: z.object({
            currentValue: z.any().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.any().nullable(),
          }),
          outerPacks: z.array(
            z.object({
              unitOfMeasure: z.string(),
              value: z.number(),
            }),
          ),
          purchaseOrderNumbers: z.array(z.any()),
          requestedDeliveryDate: z.object({
            currentValue: z.any().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.any().nullable(),
          }),
          requestedPickupDate: z.object({
            currentValue: z.any().nullable(),
            hasChanged: z.boolean(),
            previousValue: z.any().nullable(),
          }),
          sealNumber: z.string(),
          stops: z.array(
            z.object({
              actualArrivalDate: z.object({
                currentValue: z.string(),
                hasChanged: z.boolean(),
                previousValue: z.string(),
              }),
              actualDepartureDate: z.object({
                currentValue: z.string(),
                hasChanged: z.boolean(),
                previousValue: z.string(),
              }),
              address: z.object({
                address1: z.string(),
                address2: z.any().nullable(),
                city: z.string(),
                country: z.string(),
                postalCode: z.union([z.string(), z.number()]),
                stateProvinceCode: z.string(),
              }),
              estimatedArrivalDate: z.object({
                currentValue: z.string(),
                hasChanged: z.boolean(),
                previousValue: z.string(),
              }),
              locationCode: z.string(),
              name: z.string(),
              sequenceNumber: z.number(),
              stopType: z.string(),
              unLocode: z.string(),
            }),
          ),
          totalGrossWeight: z.object({
            kilograms: z.number(),
            pounds: z.number(),
          }),
          totalNetWeight: z.object({
            kilograms: z.number(),
            pounds: z.number(),
          }),
          totalVolume: z.object({
            cubicFeet: z.number(),
            cubicMeters: z.number(),
          }),
        }),
      ),
      estimatedVesselArrivalDate: z.object({
        currentValue: z.string(),
        hasChanged: z.boolean(),
        previousValue: z.string(),
      }),
      estimatedVesselDepartureDate: z.object({
        currentValue: z.string(),
        hasChanged: z.boolean(),
        previousValue: z.string(),
      }),
      houseBillNumber: z.string(),
      masterBillNumber: z.string(),
      oceanMainlineCarrier: z.object({
        bookingNumber: z.string(),
        carrierName: z.string(),
        carrierScac: z.any().nullable(),
        vesselImo: z.string(),
        vesselName: z.string(),
        voyageNumber: z.string(),
      }),
    }),
    purchaseOrderNumbers: z.array(z.any()),
    serviceLevel: z.string(),
    servicesProvidedByChr: z.array(z.string()),
    shipmentCreatedDate: z.string(),
    shipmentNumber: z.string(),
    shipmentType: z.string(),
    shipper: z.object({
      name: z.string(),
    }),
    status: z.string(),
  }),
})

export const proNumberAddedSchema = z.object({
  time: z.string(),
  customer: z.string(),
  eventTime: z.string(),
  customerReferenceNumber: z.string().nullable(),
  billToReferenceNumber: z.string(),
  event: z.object({
    eventType: z.literal('PRO NUMBER ADDED'),
    orderDetails: z.array(
      z.object({
        orderNumber: z.number(),
        customerOrderReferenceNumber: z.string().nullable(),
        billToReferenceNumber: z.string().nullable().optional(),
        navisphereTrackingNumber: z.string(),
        navisphereTrackingLink: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    loadDetails: z
      .object({
        loadNumber: z.number(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      })
      .nullable(),
    loadNumber: z.number(),
    equipmentType: z.string(),
    mode: z.string(),
    serviceOffering: z.string(),
    readyByDate: z.string(),
    pickupByDate: z.string(),
    deliveryAvailableByDate: z.string(),
    deliveryByDate: z.string(),
    proposedCarrier: z
      .object({
        carrierCode: z.string(),
      })
      .nullable(),
    billTos: z.array(
      z.object({
        customerCode: z.string(),
        customerName: z.string(),
        currencyCode: z.string(),
        invoiceMethod: z.string(),
        milesBilled: z.number(),
        exchangeRate: z.number().nullable(),
        charges: z.array(
          z.object({
            rate: z.number(),
            rateCode: z.string(),
            quantity: z.number(),
            alternateDescription: z.string(),
            chargeType: z.string(),
          }),
        ),
        contacts: z.array(
          z.object({
            name: z.string(),
            type: z.string().nullable(),
            companyName: z.string().nullable(),
            contactMethods: z.array(
              z.object({
                method: z.string(),
                value: z.string(),
              }),
            ),
            referenceNumbers: z.null(),
          }),
        ),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
    customers: z.array(
      z.object({
        customerCode: z.string(),
        customerName: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        ebolEnabledWithCarrier: z.boolean(),
        contacts: z.array(
          z.object({
            name: z.string(),
            type: z.string(),
            companyName: z.null(),
            contactMethods: z.array(z.any()),
            referenceNumbers: z.null(),
          }),
        ),
      }),
    ),
    carrier: z.object({
      name: z.string().nullable(),
      carrierCode: z.string().nullable(),
      scac: z.string().nullable(),
      proNumber: z.string().nullable(),
      driverName: z.string().nullable(),
      driverPhone: z.string().nullable(),
      secondDriverName: z.string().nullable(),
      sealNumber: z.string().nullable(),
      licensePlate: z.string().nullable(),
      tractorNumber: z.string().nullable(),
      trailerNumber: z.string().nullable(),
      dotNumber: z.string().nullable(),
      barcode: z.string().nullable().optional(),
      ebolEnabled: z.boolean().nullable().optional(),
    }),
    locations: z.array(
      z.object({
        chrLocationId: z.string(),
        customerLocationId: z.string().nullable(),
        type: z.string(),
        style: z.string(),
        stopSequenceNumber: z.number(),
        sequenceNumber: z.number(),
        name: z.string(),
        address: z.object({
          addressLine1: z.string(),
          addressLine2: z.string().nullable(),
          city: z.string(),
          stateProvinceCode: z.string(),
          postalCode: z.string(),
          country: z.string(),
          latitude: z.number().nullable(),
          longitude: z.number().nullable(),
        }),
        pickUpNumber: z.string().nullable(),
        deliveryNumber: z.string().nullable(),
        locationContact: z.object({
          name: z.string(),
          phoneNumber: z.string(),
          email: z.string().nullable(),
        }),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        appointmentNumber: z.string().nullable(),
        scheduledOpenDateTime: z.string().nullable(),
        scheduledCloseDateTime: z.string().nullable(),
        scheduledEnteredDate: z.string().nullable(),
        arrivalDateTime: z.string().nullable(),
        departureDateTime: z.string().nullable(),
        isDropTrailerNeeded: z.boolean(),
        scheduledWith: z.string().nullable(),
        etaDateTime: z.string().nullable(),
      }),
    ),
    items: z.array(
      z.object({
        packagingType: z.string(),
        description: z.string(),
        productCode: z.string(),
        freightClass: z.nullable(z.any()),
        insuranceValue: z.number(),
        primaryReferenceNumber: z.nullable(z.any()),
        poNumber: z.string(),
        skuNumber: z.string(),
        pluNumber: z.nullable(z.any()),
        actualQuantity: z.number(),
        actualWeight: z.number(),
        actualWeightUnitOfMeasure: z.string(),
        actualPallets: z.nullable(z.any()),
        actualVolume: z.number(),
        actualVolumeUnitOfMeasure: z.string(),
        actualPackagingLength: z.nullable(z.any()),
        actualPackagingHeight: z.nullable(z.any()),
        actualPackagingWidth: z.nullable(z.any()),
        actualPackagingUnitOfMeasure: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
        associatedStop: z.object({
          pickSequenceNumber: z.number(),
          dropSequenceNumber: z.number(),
        }),
        expectedPallets: z.nullable(z.any()),
        expectedQuantity: z.number(),
        expectedWeight: z.number(),
        expectedWeightUnitOfMeasure: z.string(),
        expectedPackagingLength: z.nullable(z.any()),
        expectedPackagingHeight: z.nullable(z.any()),
        expectedPackagingWidth: z.nullable(z.any()),
        expectedPackagingUnitOfMeasure: z.string(),
        expectedVolume: z.nullable(z.any()),
        expectedVolumeUnitOfMeasure: z.nullable(z.any()),
      }),
    ),
    packages: z.array(
      z.object({
        trackingNumber: z.string(),
        packageType: z.string(),
        referenceNumbers: z.array(
          z.object({
            type: z.string(),
            value: z.string(),
          }),
        ),
      }),
    ),
  }),
})
